import { WebColors } from '@sparelabs/colors'
import React from 'react'
import styled from 'styled-components'

const ProgressBarTrack = styled.div`
  height: 4px;
  width: 100%;
  background-color: ${WebColors.interactiveLowContrast};
`

const ProgressBarFill = styled.div<any>`
  width: ${(props: { percentComplete: number }) => props.percentComplete}%;
  height: 100%;
  background-color: ${WebColors.interactivePrimary};
`

export const ProgressBar = ({ percentComplete }: { percentComplete: number }) => (
  <ProgressBarTrack>
    <ProgressBarFill percentComplete={percentComplete} />
  </ProgressBarTrack>
)
